export default "__VITE_ASSET__e38$8IWt__"